export default String.raw`
{% assign product = include %}

{% include 'partials/common/card-product.html' -%}
`